import React from 'react'
import { translate } from '../Services/translation'

const DirectionsButton = (props) => {
    return (
        <>
            {props.address && (
                <div className="directions-button__container">
                    <a
                        href={`https://www.google.com/maps/dir/?api=1&destination=${props.address}`}
                        target="_blank"
                        className="directions-button__container--button"
                    >
                        {translate('directionsbutton')}
                    </a>
                </div>
            )}
        </>
    )
}

export default DirectionsButton
